import { store } from "@/store";
import * as Translate from "@/services/Translate";

export const setPageLanguage = (to:any, from:any, next:any) => {
	if(Translate.isLanguageSupported(to.query.l)){
		store.commit("localization/setPreferredLanguage", to.query.l);
	}
	next();
};